//dependencias
import React, { Component } from 'react';

//componentes
import EvaluacionAction from './consultaEvaluacion'

class Index extends Component {

    render(){
        return(
            <div>
                <EvaluacionAction />
            </div>
        );
    }

}
export default Index;